import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { IModalContent } from 'core-components/library/modalDialog'
import { IPendingButton, IPendingDescription } from 'src/core/routes/urlController/URLContext'

import styles from './UrlControllerQuestion.module.scss'

export interface IQuestionProps {
  activeOperation: IPendingDescription
  onChoose: any
  onEndOperation: any
}
export const UrlControllerQuestion = (props: IQuestionProps & IModalContent) => {
  const [loader, setLoader] = useState(false)
  const [warning, setWarning] = useState('')
  const changedFields =
    props.activeOperation.calculateChangedFields && props.activeOperation.calculateChangedFields()
  return (
    <div className={styles.dialogContainer}>
      <p className={styles.confirmTitle}>Please confirm step</p>
      {props.activeOperation.message} <br />
      <br />
      {changedFields && !!changedFields.length && (
        <div>
          <strong>Changed fields: </strong>
          {changedFields.join(', ')}
        </div>
      )}
      {loader ? (
        <Loader />
      ) : (
        <div className={styles.buttons}>
          {props.activeOperation.buttons.map((but: IPendingButton, key: number) => (
            <Button
              {...(!but.calculateProps
                ? but.props || {}
                : Object.assign({}, but.props || {}, but.calculateProps()))}
              key={key}
              onClick={() => {
                setLoader(true)
                but
                  .callback()
                  .then((result) => {
                    if (result) {
                      props.onChoose()
                    }
                    setLoader(false)
                    props.closeModal()
                    props.onEndOperation(result)
                  })
                  .catch((e) => {
                    setLoader(false)
                    setWarning(e.message)
                  })
              }}
            />
          ))}
        </div>
      )}
      <div>{warning}</div>
    </div>
  )
}
